import { Model } from "../decorators/model.decorator";
import { Column } from "../decorators/column.decorator";
import { BaseModel } from "./base.model";

@Model('productBookAuthor', ['productBookAuthors'])
export class ProductBookAuthor extends BaseModel {
  @Column()
  id: number | undefined;
  @Column()
  name: string | undefined;
  @Column()
  vita: string | undefined;
  @Column()
  role: string | undefined;
}
